import create from 'zustand'

const UseStore = create((set) =>({
    mcq_1: null,
    setMcq_1: (values) => set(state => ({ mcq_1: values})),
    mcq_2: null,
    setMcq_2: (values) => set(state => ({ mcq_2: values})),
    mcq_3: null,
    setMcq_3: (values) => set(state => ({ mcq_3: values})),
    mpUser: null,
    setMpUser: (values) => set(state => ({mpUser: values}))
}))

export default UseStore